// Lista canônica confirmada com o usuário (2026-08-24): todas as unidades estão
// ativas, exceto ISTAI (fica de fora de propósito).
//
// labelRelatorio: texto descritivo usado pelos 3 Selects de Relatório
// (TabelaRelatorio/Select, Grafico/Select, Cursos/Select), que já eram cópias
// byte-a-byte um do outro — texto reaproveitado como estava, não inventado.
const UNIDADES = [
    { sigla: "SL", nome: "CEP PROF. STÊNIO LOPES", ativo: true, labelRelatorio: "Centro de Formação Profissional Prof. Stenio Lopes (SL)" },
    { sigla: "ORC", nome: "CEP ODILON RIBEIRO COUTINHO", ativo: true, labelRelatorio: "Centro de Educação Profissional Odilon Ribeiro Coutinho (ORC)" },
    { sigla: "JWLL", nome: "CEP JOSÉ WILLIAM LEMOS LEAL", ativo: true, labelRelatorio: "Centro de Formação Profissional José William Lemos Leal (JWLL)" },
    { sigla: "CTCC", nome: "CTCC ALBANO FRANCO", ativo: true, labelRelatorio: "Centro de Tecnologia do Couro e do Calçado Albano Franco (CTCC)" },
    { sigla: "CITI/CAM", nome: "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL", ativo: true, labelRelatorio: "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL (CITI/CAM)" },
    { sigla: "MBG", nome: "CFP MIRIAM BENEVIDES GADELHA", ativo: true, labelRelatorio: "Centro de Formação Profissional Miriam Benevides Gadelha (MBG)" },
    { sigla: "ISTAI", nome: "IST AUTOMAÇÃO INDUSTRIAL", ativo: false, labelRelatorio: "Instituto SENAI de Tecnologia em Automação (ISTAI)" },
    { sigla: "ISTTC", nome: "IST TÊXTIL E CONFECÇÕES", ativo: true, labelRelatorio: "Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)" },
    { sigla: "ISTEO", nome: "IST EFICIÊNCIA OPERACIONAL", ativo: true, labelRelatorio: "IST Eficiência Operacional (ISTEO)" },
    { sigla: "FACULDADE", nome: "FACULDADE SENAI", ativo: true, labelRelatorio: "FACULDADE SENAI" },
    { sigla: "RBA", nome: "ROBSON BRAGA DE ANDRADE", ativo: true, labelRelatorio: "Centro de Formação Profissional Robson Braga de Andrade (RBA)" },
];

const UNIDADES_ATIVAS = UNIDADES.filter((u) => u.ativo);

function parseUnidade(nome) {
    nome = nome && nome.toUpperCase();
    let unidade = UNIDADES.find((u) => u.nome === nome);
    return unidade && unidade.sigla;
}

function parseUnidadeSigla(sigla) {
    sigla = sigla && sigla.toUpperCase();
    let unidade = UNIDADES.find((u) => u.sigla === sigla);
    return unidade && unidade.nome;
}

module.exports = {
    UNIDADES,
    UNIDADES_ATIVAS,
    parseUnidade,
    parseUnidadeSigla
};
